import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Grid,
  Collapse,
  Typography,
  IconButton,
  Card,
  CardContent,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import textLabels from "../../components/dataTable/textLabel";

const DetailsMail = ({ data }) => {
  const [openRows, setOpenRows] = useState({});

  const handleToggle = (index) => {
    setOpenRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const columns = [
    { name: "nom", label: "Nom" },
    { name: "prenom", label: "Prénom" },
    { name: "dateEnvoie", label: "Date d'envoi" },
    { name: "format", label: "Format" },
    {
      name: "erreur",
      label: "Envoyé",
      options: {
        customBodyRender: (value) => {
          return value === "envoye" ? (
            <CheckCircleIcon style={{ color: "green" }} />
          ) : (
            <CancelIcon style={{ color: "red" }} />
          );
        },
      },
    },
    { name: "body", label: "body", options: { display: "excluded" } },
    {
      name: "voir",
      label: "Voir",
      options: {
        customBodyRender: (value, tableMeta) => {
          const isOpen = openRows[tableMeta.rowIndex];
          return (
            <IconButton onClick={() => handleToggle(tableMeta.rowIndex)}>
              {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          );
        },
      },
    },
  ];

  const options = {
    search: true,
    filter: false,
    sort: false,
    download: false,
    print: false,
    selectableRows: "none",
    viewColumns: false,
    pagination: true,
    textLabels: textLabels,
  };

  return (
    <div>
      <MUIDataTable
        title={"Détails"}
        data={data}
        columns={columns}
        options={options}
      />
      {data.map((row, index) => (
        <Collapse key={index} in={openRows[index]}>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ width: "calc(150vh - 300px)" }}>
              <Card style={{ marginTop: 16 }}>
                <CardContent>
                  <Typography variant="h6">
                    Contenu du message adressé à{" "}
                    <span style={{ fontWeight: "bold" }}>
                      {row.nom} {row.prenom}{" "}
                    </span>
                    le {row.dateEnvoie} :
                  </Typography>
                  <div dangerouslySetInnerHTML={{ __html: row.body }} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Collapse>
      ))}
    </div>
  );
};

export default DetailsMail;
